"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Color_meta_1 = require("./Color.meta");

var Color =
/** @class */
function (_super) {
  __extends(Color, _super);

  function Color(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Color_meta_1.COLOR_CATEGORY_KEY;
    _this.componentKey = Color_meta_1.COLOR_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Color.prototype, "color", {
    get: function get() {
      var _a = this.props,
          _b = _a.aliases,
          aliases = _b === void 0 ? [] : _b,
          value = _a.color;
      var alias = aliases.find(function (a) {
        return a.value === value;
      });

      if (alias && alias.color) {
        return alias.color;
      }

      if (typeof value === "string") {
        return value;
      }

      if (!ksys_app_template_1.utils.typeChecks.isNullOrUndefined(value)) {
        return value.toString();
      }

      return "#ffffff";
    },
    enumerable: true,
    configurable: true
  });

  Color.prototype.render = function () {
    var className = this.props.className;
    var color = this.color;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      style: {
        backgroundColor: color
      }
    }, "\xA0");
  };

  Color = __decorate([mobx_react_1.observer], Color);
  return Color;
}(shared_1.ComponentBase);

exports.Color = Color;
exports.default = shared_1.InjectedStyledComponent(Color, Color_meta_1.COLOR_CATEGORY_KEY, Color_meta_1.COLOR_COMPONENT_KEY);